import { LOCALES, useLocale, useT } from "../i18n";

export function LangToggle() {
  const [locale, setLocale] = useLocale();
  const t = useT();

  return (
    <div
      role="radiogroup"
      aria-label={t.menu.language}
      className="inline-flex items-center gap-0.5 rounded-lg border border-zinc-200 bg-white p-0.5 dark:border-zinc-800 dark:bg-zinc-900"
    >
      {LOCALES.map((l) => (
        <button
          key={l}
          role="radio"
          aria-checked={locale === l}
          onClick={() => setLocale(l)}
          className={`rounded-md px-2 py-1 text-xs font-semibold uppercase transition-colors ${
            locale === l
              ? "bg-zinc-100 text-zinc-900 dark:bg-zinc-700 dark:text-zinc-50"
              : "text-zinc-400 hover:text-zinc-600 dark:text-zinc-500 dark:hover:text-zinc-300"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
